var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack241({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.19,6.05a2.51,2.51,0,0,1,.5-1.71,1.78,1.78,0,0,1,1.38-.55,1.79,1.79,0,0,1,1.4.55A2.46,2.46,0,0,1,7,6.05a2.46,2.46,0,0,1-.51,1.71,1.74,1.74,0,0,1-1.37.56,1.82,1.82,0,0,1-1.41-.55A2.52,2.52,0,0,1,3.19,6.05ZM4.47,6a2.23,2.23,0,0,0,.19,1.13.51.51,0,0,0,.82,0A2.35,2.35,0,0,0,5.67,6a2.3,2.3,0,0,0-.19-1.12.51.51,0,0,0-.82,0A2.19,2.19,0,0,0,4.47,6Zm1.85,6.81H5.1L9.68,3.79h1.18ZM9,10.59a2.46,2.46,0,0,1,.51-1.71,1.78,1.78,0,0,1,1.38-.55,1.81,1.81,0,0,1,1.4.55,2.51,2.51,0,0,1,.5,1.71,2.52,2.52,0,0,1-.5,1.72,1.79,1.79,0,0,1-1.38.56,1.8,1.8,0,0,1-1.4-.56A2.47,2.47,0,0,1,9,10.59Zm1.28,0a2.16,2.16,0,0,0,.2,1.12.46.46,0,0,0,.4.21.47.47,0,0,0,.41-.21,2.19,2.19,0,0,0,.19-1.12,2.23,2.23,0,0,0-.19-1.13.47.47,0,0,0-.41-.21.45.45,0,0,0-.4.21A2.21,2.21,0,0,0,10.26,10.59Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack241);
export default __webpack_public_path__ + "static/media/Symbolpack_2_41.4f7c997d3644a5115c2a7e452fb60d80.svg";
export { ForwardRef as ReactComponent };